import { render, staticRenderFns } from "./Game_Mail.vue?vue&type=template&id=b87d0eb8&scoped=true&"
import script from "./Game_Mail.vue?vue&type=script&lang=js&"
export * from "./Game_Mail.vue?vue&type=script&lang=js&"
import style0 from "./Game_Mail.vue?vue&type=style&index=0&id=b87d0eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87d0eb8",
  null
  
)

export default component.exports